import { marks } from '../utils/api'
import { createAlert } from './alertActions'
import { ERROR } from '../components/AlertListItem'
import I18n from 'i18n'

export const ADD_MARK_REQUEST = 'tru/ADD_MARK_REQUEST'
export const ADD_MARK_SUCCESS = 'tru/ADD_MARK_SUCCESS'
export const ADD_MARK_FAILURE = 'tru/ADD_MARK_FAILURE'

export const UPDATE_MARK_REQUEST = 'tru/UPDATE_MARK_REQUEST'
export const UPDATE_MARK_SUCCESS = 'tru/UPDATE_MARK_SUCCESS'
export const UPDATE_MARK_FAILURE = 'tru/UPDATE_MARK_FAILURE'

export const REMOVE_MARK_REQUEST = 'tru/REMOVE_MARK_REQUEST'
export const REMOVE_MARK_SUCCESS = 'tru/REMOVE_MARK_SUCCESS'
export const REMOVE_MARK_FAILURE = 'tru/REMOVE_MARK_FAILURE'

export const addMarkRequest = mark => ({
  type: ADD_MARK_REQUEST,
  mark
})

export const addMarkSuccess = success => ({
  type: ADD_MARK_SUCCESS,
  success
})

export const addMarkFailure = errors => ({
  type: ADD_MARK_FAILURE,
  errors
})

export const updateMarkRequest = mark => ({
  type: UPDATE_MARK_REQUEST,
  mark
})

export const updateMarkSuccess = success => ({
  type: UPDATE_MARK_SUCCESS,
  success
})

export const updateMarkFailed = errors => ({
  type: UPDATE_MARK_FAILURE,
  errors
})

export const removeMarkRequest = id => ({
  type: REMOVE_MARK_REQUEST,
  id
})

export const removeMarkSuccess = success => ({
  type: REMOVE_MARK_SUCCESS,
  success
})

export const removeMarkFailed = errors => ({
  type: REMOVE_MARK_FAILURE,
  errors
})

export const addMark = mark => dispatch => {
  if (mark.text.trim()) {
    return marks.add(mark).then(
      data => {
        dispatch(addMarkSuccess())
        return data.data
      },
      error => {
        dispatch(addMarkFailure(error))
        dispatch(
          createAlert({
            scope: 'mark',
            type: ERROR,
            message: I18n.t(
              `There was a problem saving your mark.
                  Please try again.`
            )
          })
        )
      }
    )
  }
  dispatch(
    createAlert({
      scope: 'mark',
      type: ERROR,
      message: I18n.t("Mark Name: This is a mandatory field, can't be blank")
    })
  )
}

export const updateMark = mark => dispatch => {
  dispatch(updateMarkRequest(mark))
  if (mark.text.trim()) {
    return marks.update(mark).then(
      () => dispatch(updateMarkSuccess()),
      error => {
        dispatch(updateMarkFailed(error))
        dispatch(
          createAlert({
            scope: 'mark',
            type: ERROR,
            message: I18n.t(
              `There was a problem saving your mark.
                  Please try again.`
            )
          })
        )
      }
    )
  }
  dispatch(
    createAlert({
      scope: 'mark',
      type: ERROR,
      message: I18n.t("Mark Name: This is a mandatory field, can't be blank")
    })
  )
}

export const removeMark = id => dispatch => {
  dispatch(removeMarkRequest(id))

  return marks.remove(id).then(
    () => dispatch(removeMarkSuccess()),
    error => {
      dispatch(removeMarkFailed(error))
      dispatch(
        createAlert({
          scope: 'mark',
          type: ERROR,
          message: I18n.t(
            `There was a problem deleting your mark.
                Please try again.`
          )
        })
      )
    }
  )
}



// WEBPACK FOOTER //
// ../src/actions/markActions.js